export default __webpack_public_path__ + "static/media/attachment.bfb32894.svg";